/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './intra-op-nursing-record.reducer';

export const IntraOPNursingRecord = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const intraOPNursingRecordList = useAppSelector(state => state.intraOPNursingRecord.entities);
  const loading = useAppSelector(state => state.intraOPNursingRecord.loading);
  const totalItems = useAppSelector(state => state.intraOPNursingRecord.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="intra-op-nursing-record-heading" data-cy="IntraOPNursingRecordHeading">
        <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.home.title">Intra OP Nursing Records</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/intra-op-nursing-record/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.home.createLabel">Create new Intra OP Nursing Record</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.intraOPNursingRecord.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {intraOPNursingRecordList && intraOPNursingRecordList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('procedureStart')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.procedureStart">Procedure Start</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureStart')} />
                </th>
                <th className="hand" onClick={sort('procedureEnd')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.procedureEnd">Procedure End</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureEnd')} />
                </th>
                <th className="hand" onClick={sort('specimen')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.specimen">Specimen</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('specimen')} />
                </th>
                <th className="hand" onClick={sort('timeSent')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeSent">Time Sent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timeSent')} />
                </th>
                <th className="hand" onClick={sort('timeOfReport')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeOfReport">Time Of Report</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timeOfReport')} />
                </th>
                <th className="hand" onClick={sort('countsCorrect')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.countsCorrect">Counts Correct</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('countsCorrect')} />
                </th>
                <th className="hand" onClick={sort('surgeonInformed')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.surgeonInformed">Surgeon Informed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('surgeonInformed')} />
                </th>
                <th className="hand" onClick={sort('timeInformed')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeInformed">Time Informed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timeInformed')} />
                </th>
                <th className="hand" onClick={sort('actionRemarks')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionRemarks">Action Remarks</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actionRemarks')} />
                </th>
                <th className="hand" onClick={sort('actionTaken')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionTaken">Action Taken</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actionTaken')} />
                </th>
                <th className="hand" onClick={sort('conditionAtEnd')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.conditionAtEnd">Condition At End</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('conditionAtEnd')} />
                </th>
                <th className="hand" onClick={sort('equipmentProblem')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.equipmentProblem">Equipment Problem</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('equipmentProblem')} />
                </th>
                <th className="hand" onClick={sort('equipmentProblemNotes')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.equipmentProblemNotes">Equipment Problem Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('equipmentProblemNotes')} />
                </th>
                <th className="hand" onClick={sort('actionNotes')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionNotes">Action Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actionNotes')} />
                </th>
                <th className="hand" onClick={sort('implant')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.implant">Implant</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('implant')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.scrubNurse">Scrub Nurse</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.circulatingNurse">Circulating Nurse</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {intraOPNursingRecordList.map((intraOPNursingRecord, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/intra-op-nursing-record/${intraOPNursingRecord.id}`} color="link" size="sm">
                      {intraOPNursingRecord.id}
                    </Button>
                  </td>
                  <td>{intraOPNursingRecord.procedureStart}</td>
                  <td>{intraOPNursingRecord.procedureEnd}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Specimen.${intraOPNursingRecord.specimen}`} />
                  </td>
                  <td>{intraOPNursingRecord.timeSent}</td>
                  <td>{intraOPNursingRecord.timeOfReport}</td>
                  <td>{intraOPNursingRecord.countsCorrect ? 'true' : 'false'}</td>
                  <td>{intraOPNursingRecord.surgeonInformed ? 'true' : 'false'}</td>
                  <td>{intraOPNursingRecord.timeInformed}</td>
                  <td>{intraOPNursingRecord.actionRemarks}</td>
                  <td>{intraOPNursingRecord.actionTaken ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientCondition.${intraOPNursingRecord.conditionAtEnd}`} />
                  </td>
                  <td>{intraOPNursingRecord.equipmentProblem ? 'true' : 'false'}</td>
                  <td>{intraOPNursingRecord.equipmentProblemNotes}</td>
                  <td>{intraOPNursingRecord.actionNotes}</td>
                  <td>{intraOPNursingRecord.implant ? 'true' : 'false'}</td>
                  <td>{intraOPNursingRecord.active ? 'true' : 'false'}</td>
                  <td>{intraOPNursingRecord.cursor}</td>
                  <td>{intraOPNursingRecord.lastupdated}</td>
                  <td>{intraOPNursingRecord.microSec}</td>
                  <td>{intraOPNursingRecord.timestampentry}</td>
                  <td>
                    {intraOPNursingRecord.surgery ? (
                      <Link to={`/patient-procedure/${intraOPNursingRecord.surgery.id}`}>{intraOPNursingRecord.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {intraOPNursingRecord.scrubNurse ? (
                      <Link to={`/nurse/${intraOPNursingRecord.scrubNurse.id}`}>{intraOPNursingRecord.scrubNurse.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {intraOPNursingRecord.circulatingNurse ? (
                      <Link to={`/nurse/${intraOPNursingRecord.circulatingNurse.id}`}>{intraOPNursingRecord.circulatingNurse.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/intra-op-nursing-record/${intraOPNursingRecord.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/intra-op-nursing-record/${intraOPNursingRecord.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/intra-op-nursing-record/${intraOPNursingRecord.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.home.notFound">No Intra OP Nursing Records found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={intraOPNursingRecordList && intraOPNursingRecordList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default IntraOPNursingRecord;
